module.exports = __webpack_public_path__ + "img/selfie.b23c7278.png";